import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import type { CustomLoadingOverlayProps } from "ag-grid-react";
const contentStyle: React.CSSProperties = {
    padding: 50,
    background: 'rgba(0, 0, 0, 0)',
    borderRadius: 4,
  };

export default (
    props: { message: string },
) => {
  return (
    <Spin tip={props.message}  className="text-red" size="large" indicator={<LoadingOutlined spin />} style={{color:'rgb(31, 28, 37)' }}>
        <div style={contentStyle} className='text-red' />
    </Spin>
  );
};